import moment from 'moment'
import 'moment/locale/pt-br'

moment.locale('pt-br')

const date = (value, format = 'DD/MM/YYYY') => {
  if (!value) return null

  let m

  if (typeof value === 'string') {
    m = moment(
      value,
      [
        moment.ISO_8601,
        'L',
        'l',
        'DD/MM/YYYY',
        'DD/MM/YYYY HH:mm',
        'DD/MM/YYYY HH:mm:ss',
      ],
      true,
    )
  } else {
    m = moment(value)
  }

  if (!m.isValid()) {
    return null
  }

  return m.format(format)
}

export default date
